import React, { createContext, useContext, useState, useCallback, ReactNode } from "react";

interface FeedAnimationContextType {
    showSuccessAnimation: boolean;
    showDeleteSuccessAnimation: boolean;
    deleteMessage: string;
    showSuccess: () => void;
    showDeleteSuccess: (message: string) => void;
    hideAnimations: () => void;
}

export const FeedAnimationContext = createContext<FeedAnimationContextType | undefined>(undefined);

interface FeedAnimationProviderProps {
    children: ReactNode;
}

export const FeedAnimationProvider = ({ children }: FeedAnimationProviderProps) => {
    const [showSuccessAnimation, setShowSuccessAnimation] = useState<boolean>(false);
    const [showDeleteSuccessAnimation, setShowDeleteSuccessAnimation] = useState<boolean>(false);
    const [deleteMessage, setDeleteMessage] = useState<string>("");

    const showSuccess = useCallback(() => {
        setShowSuccessAnimation(true);
    }, []);

    const showDeleteSuccess = useCallback((message: string) => {
        setDeleteMessage(message);
        setShowDeleteSuccessAnimation(true);
    }, []);

    const hideAnimations = useCallback(() => {
        setShowSuccessAnimation(false);
        setShowDeleteSuccessAnimation(false);
        setDeleteMessage("");
    }, []);

    return (
        <FeedAnimationContext.Provider
            value={{
                showSuccessAnimation,
                showDeleteSuccessAnimation,
                deleteMessage,
                showSuccess,
                showDeleteSuccess,
                hideAnimations,
            }}
        >
            {children}
        </FeedAnimationContext.Provider>
    );
};

export const useFeedAnimation = (): FeedAnimationContextType => {
    const context = useContext(FeedAnimationContext);
    if (!context) {
        throw new Error("useFeedAnimation must be used within a FeedAnimationProvider");
    }
    return context;
};
